import { render, staticRenderFns } from "./BottomCharts.vue?vue&type=template&id=5f0893ae&scoped=true&"
import script from "./BottomCharts.vue?vue&type=script&lang=js&"
export * from "./BottomCharts.vue?vue&type=script&lang=js&"
import style0 from "./BottomCharts.vue?vue&type=style&index=0&id=5f0893ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0893ae",
  null
  
)

export default component.exports